export const blockIconsEditorPostAdd = (
	<span className='material-symbols-outlined'>post_add</span>
);
